import React from 'react';
import { Form, reduxForm } from 'redux-form';
import { faArrowUp } from '@fortawesome/free-solid-svg-icons';
import { HashLoader } from 'react-spinners';

import { SimpleModalId } from '../../../../constants/modalId';
import { AppFileField } from '../../../form/appFileField';
import { AppTextField } from '../../../form/appTextField';
import { required } from '../../../form/formValidations';
import AppModal from '../../../modal/appModal';
import { allowedTemplateExtensions, validateTemplateFile } from '../../utils/fileValidators';
import styles from '../../ClipGeneratorPage.module.scss';

import {
  TemplateUploadFormDataProps,
  TemplateUploadFormOnSubmitProps,
  TemplateUploadFormOwnProps,
} from './templateForm.types';

const TemplateUploadForm = ({ form, handleSubmit, onUpload, isLoading }: TemplateUploadFormOwnProps) => {
  const handleOnSubmit = (values: TemplateUploadFormDataProps) => onUpload(values);

  return (
    <AppModal
      form={form}
      id={SimpleModalId.AddTemplateModal}
      title="Add template"
      buttonIcon={faArrowUp}
      hideActionButtons={isLoading}
      className={styles.modal}
    >
      <Form id={form} onSubmit={handleSubmit(handleOnSubmit)}>
        {!isLoading ? (
          <>
            <AppTextField name="name" label="Template name" validate={[required]} />
            <AppFileField
              name="zipFile"
              label="Template File (.zip)"
              validate={[validateTemplateFile, required]}
              extensions={allowedTemplateExtensions}
            />
          </>
        ) : (
          <div className={styles.loader}>
            <HashLoader />
          </div>
        )}
      </Form>
    </AppModal>
  );
};
export const TemplateUploadFormContainer = reduxForm<TemplateUploadFormDataProps, TemplateUploadFormOnSubmitProps>({
  form: 'templateUploadForm',
  enableReinitialize: true,
})(TemplateUploadForm);
